import { Name } from './Name'
import { Person } from './Person'
import type { ITsdContact } from '~/types/contact/models'
import {
  ContactTypeIds,
  getContactTypeById,
} from '~/services/selectLists/contactTypes'

export function TsdContact(o: ITsdContact): ITsdContact {
  const fn = '[cynqueModules/dataObjects/TsdContact.ts] Contact |'
  if (!o) {
    throw new Error(`${fn} TsdContact called with falsey tsdContact`)
  }
  if (!o.person) {
    throw new Error(`${fn} TsdContact called with falsey tsdContact.person`)
  }
  if (!o.tsd) {
    throw new Error(
      `${fn} No tsd object in tsdContact.` +
        ' This is almost certainly a programming error.'
    )
  }
  const obj = { ...o }
  obj.person = Person(o.person)
  obj.avatar = {
    descr: obj.person.name.initials ?? '',
    type: 'tsdContact',
  }
  const nameDescr = Name(o.person.name).descr ?? 'No Name'
  obj.label = nameDescr
  obj.descr = nameDescr + '\n' + (o.phone ?? o.person.phone ?? 'No Phone')
  obj.type = getContactTypeById(ContactTypeIds.TSD)
  obj.parentName = o.tsd.label
  obj.namePlusBiz =
    `${nameDescr} - ${obj.parentName} - ` +
    +(o.phone ?? o.person.phone ?? 'No Phone')
  obj.namePlusRole = `${nameDescr} - ${obj.role?.label ?? 'No role'}`

  console.debug(`${fn} returning`, obj)
  return obj
}
